// extracted by mini-css-extract-plugin
export default {"btn-wrapper":"VideoNavButton_btn-wrapper__MFVeH","icon":"VideoNavButton_icon__1mYfd","disabled":"VideoNavButton_disabled__fIBam","wrapper":"VideoNavButton_wrapper__L86G+"};